import React, { useState } from 'react';
import { LoginPage } from './LoginPage';
import { RegisterPage } from './RegisterPage';

type AuthView = 'login' | 'register';

/**
 * Unauthenticated entry point. Swaps between the reusable auth pages without
 * pulling in a router (the app uses local view state for navigation).
 */
export const AuthFlow: React.FC = () => {
  const [view, setView] = useState<AuthView>('login');

  return view === 'login' ? (
    <LoginPage onNavigateRegister={() => setView('register')} />
  ) : (
    <RegisterPage onNavigateLogin={() => setView('login')} />
  );
};
